// extracted by mini-css-extract-plugin
export default {"form":"forms_form__seJQ3","formulario":"forms_formulario__MkhSc","l":"forms_l__1Gims","password":"forms_password__YSMYt","botao":"forms_botao__ZBLI0","title":"forms_title__Nnu2r"};